export const verovioNames = {
  state: {
    vrvInitFinished: 'vrvInitFinished'
  },
  mutations: {},
  actions: {
    initVerovio: 'initVerovio'
  },
  getters: {
    vrvToolkit: 'vrvToolkit'
  }
}

export default verovioNames
